import { IPositionTypeService } from "../../service/position/PositionTypeService";

export default class GetPositionTypesInteractor {
  private positionTypeService: IPositionTypeService;

  constructor(positionTypeService) {
    this.positionTypeService = positionTypeService;
  }

  async execute() {
    return this.positionTypeService.getPositionTypes();
  }
}
